import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Button as MUIButton } from '@mui/material';

import generalContent from 'assets/content/general.content.json';

import { isAutoApplyCouponValid } from 'utils/helpers';

import style from './RentalPeriod.module.scss';

RentalPeriod.propTypes = {
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.object.isRequired,
    isSelected: PropTypes.bool.isRequired,
    editSpecification: PropTypes.bool,
    rentalOptions: PropTypes.array
};

function RentalPeriod({
    selected,
    onClick,
    rentalOptions,
    editSpecification
}) {
    const env = process.env.REACT_APP_ENV;
    const productId = selected.product_id;
    const freeOneMonthProductIds = env === 'production' ? [389, 388] : [720, 721]; // Flip6 & Fold6

    const useQueryParams = () => {
        const location = useLocation();

        return new URLSearchParams(location.search);
    };

    const queryParams = useQueryParams();
    const [formattedData, setFormattedData] = useState([]);

    const onClickSubmit = (durationTime) => {
        const rentalPeriods = rentalOptions.filter(option => option.duration_time === durationTime);

        onClick(rentalPeriods, durationTime);
    };

    useEffect(() => {
        const rentalTerm = queryParams.get('rental_term');

        if (rentalTerm === undefined) {
            const rentalPeriod = rentalOptions.filter(option => option?.duration_time === Number(rentalTerm) && option?.user_type === 'b2s');

            localStorage.setItem('selectedRentalPeriod', JSON.stringify(rentalPeriod));
        } else {
            const rentalPeriodByDefault = rentalOptions.filter(option => option?.duration_time === 12 && option?.user_type === 'b2s');

            localStorage.setItem('selectedRentalPeriod', JSON.stringify(rentalPeriodByDefault));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const rentalPeriods = rentalOptions.sort((a, b) => b.duration_time - a.duration_time).filter((period) => period.user_type === 'b2c').filter((option, i, self) => self.findIndex(o => o.duration_time === option.duration_time) === i);

        setFormattedData(rentalPeriods);
    }, [rentalOptions]);

    return (
        <div className={`${style.RentalPeriod}`}>
            <p className={style.RentalPeriod__label}>{generalContent?.GET_IT_FOR}</p>
            <div className={style.rentalOptions}>
                {formattedData && formattedData.map((option, index) => {
                    if (option.duration_time !== 0 && option.name !== 'purchase') {
                        const buttonText = option.duration_time + (option.duration_time > 1 ? ' months' : ' month');
                        const optionSelected = selected?.id === option?.id;
                        const optionClass = optionSelected ? style.rentalOption + ' ' + style.selected : style.rentalOption;
                        const isFreeOneMonth = freeOneMonthProductIds.includes(productId) && option.duration_time === 12 && isAutoApplyCouponValid();

                        return <MUIButton key={index} variant='outlined' disableRipple={true}
                            size='large' className={optionClass} onClick={() => onClickSubmit(option?.duration_time)}>
                            <span>{buttonText}</span>
                            {isFreeOneMonth && (
                                <small className={style.freeOneMonth}>FREE +1 Month</small>
                            )}
                        </MUIButton>;
                    }

                    return null;
                })}
            </div>
        </div>
    );
}

export default RentalPeriod;
